import { useEffect, useState } from 'react';
import { jwtDecode } from 'jwt-decode';

/**
 * Fast authentication check component that runs before React Admin initializes
 * This prevents the delay when checking authentication status
 */
export const FastAuthCheck = ({ children }) => {
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    // Perform fast synchronous auth check
    const checkAuthFast = () => {
      const token = localStorage.getItem('token');
      
      if (!token) {
        // No token - redirect to login immediately
        if (!window.location.hash.includes('/login')) {
          window.location.hash = '#/login';
        }
        setAuthChecked(true);
        return;
      }

      // Validate token
      try {
        const decodedToken = jwtDecode(token);
        const currentTime = Date.now() / 1000;
        
        if (decodedToken.exp && decodedToken.exp < currentTime) {
          // Token expired - clear and redirect
          localStorage.removeItem('token');
          localStorage.removeItem('userId');
          localStorage.removeItem('userRole');
          localStorage.removeItem('userTeamId');
          localStorage.removeItem('username');
          localStorage.removeItem('teamName');
          
          if (!window.location.hash.includes('/login')) {
            window.location.hash = '#/login';
          }
        }
      } catch (error) {
        // Invalid token - clear and redirect
        localStorage.removeItem('token');
        if (!window.location.hash.includes('/login')) {
          window.location.hash = '#/login';
        }
      }
      
      setAuthChecked(true);
    };

    // Run check immediately
    checkAuthFast();
  }, []);

  // Don't render React Admin until auth check is complete
  if (!authChecked) {
    return null; // Or a minimal loading indicator if desired
  }

  return children;
};